import * as React from "react";
const SvgRefreshCw02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.965 20v-6c0-.572.463-1.035 1.035-1.035h6a1.035 1.035 0 0 1 0 2.07H3.95c.512.612 1.277 1.456 2.418 2.597a7.964 7.964 0 0 0 11.264 0 7.9 7.9 0 0 0 2.135-3.862 1.036 1.036 0 0 1 2.018.46 10 10 0 0 1-2.69 4.866c-3.918 3.919-10.272 3.919-14.19 0a51 51 0 0 1-1.87-1.96V20a1.035 1.035 0 0 1-2.07 0m3.94-15.096c3.918-3.919 10.272-3.919 14.19 0a52 52 0 0 1 1.87 1.96V4a1.035 1.035 0 0 1 2.07 0v6c0 .572-.463 1.035-1.035 1.035h-6a1.035 1.035 0 0 1 0-2.07h4.05c-.512-.612-1.277-1.455-2.418-2.597A7.964 7.964 0 0 0 4.233 10.23a1.036 1.036 0 0 1-2.018-.458 10 10 0 0 1 2.69-4.867"
}));
export default SvgRefreshCw02;
//# sourceMappingURL=RefreshCw02.js.map